import ClearIcon from "@mui/icons-material/Clear";
import { Chip as MuiChip, styled } from "@mui/material";
import React from "react";
/**
 * Custom Chip control.
 * @param props @see ChipProps
 *
 */
export function Chip({ variant, text, onDelete, className, disabled }) {
    const classes = {
        root: "chip-root",
        outlinedPrimary: "chip-outlinedPrimary",
        deleteIcon: "chip-deleteIcon",
        clickable: "chip-clickable"
    };
    const StyledMuiChip = styled(MuiChip)(({ theme }) => ({
        [`&.${classes.root}`]: {
            boxShadow: "1px 1px 2px 0 rgba(0, 255, 0, 0.1)",
            height: "29px"
        },
        [`&.${classes.outlinedPrimary}`]: {
            border: `1px solid ${theme.palette.primary.main}`,
            borderRadius: "6px!important",
            color: theme.palette.text.primary,
            [`& .${classes.clickable}`]: {
                "&:hover": {
                    backgroundColor: "white"
                },
                "&:focus": {
                    backgroundColor: theme.palette.background.focus
                }
            }
        },
        [`& .${classes.deleteIcon}`]: {
            width: "20px",
            height: "20px",
            "&:hover": {
                backgroundColor: theme.palette.background.hover,
                borderRadius: "50%"
            }
        },
        [`&.${classes.clickable}`]: {
            "&:hover": {
                backgroundColor: "white"
            }
        }
    }));
    return (React.createElement(StyledMuiChip, { classes: { root: classes.root, outlinedPrimary: classes.outlinedPrimary, deleteIcon: classes.deleteIcon, clickable: classes.clickable }, clickable: true, color: variant === "primary" ? "primary" : "default", deleteIcon: React.createElement(ClearIcon, null), label: text, onDelete: onDelete, variant: variant === "primary" ? "outlined" : "filled", className: className, disabled: disabled }));
}
//Prop defaults
Chip.defaultProps = {
    variant: "default",
    disabled: false
};
